module.exports = __webpack_public_path__ + "assets/46c1924ee371d05c9479428a7eca47d9.png";